// extracted by mini-css-extract-plugin
export default {"zoomModal":"X2-z","image":"Y2-z","button":"Z2-z","isOverlayShown":"_2-z"};